import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=052f7336&scoped=true&"
import script from "./QuestionList.vue?vue&type=script&lang=js&"
export * from "./QuestionList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=052f7336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052f7336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('052f7336')) {
      api.createRecord('052f7336', component.options)
    } else {
      api.reload('052f7336', component.options)
    }
    module.hot.accept("./QuestionList.vue?vue&type=template&id=052f7336&scoped=true&", function () {
      api.rerender('052f7336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/samurai/Settings/components/QuestionList.vue"
export default component.exports